import constants from './constants.js'
import moment from 'moment/moment.js'

/**
  * @desc   formats side menu items based on data
  * @param  permissions object - user permissions
  * @return object - formatted menu object
*/
function formatSlideMenuItems (permissions) {
  let showDashboard = (permissions.ServiceMonitoring || []).length > 0
  let showReception = (permissions.ReceptionAppointments || []).length > 0
  let showDispatch = (permissions.DispatchAppointments || []).length > 0
  let showInventory = (permissions.Inventory || []).length > 0
  let showSearchDocuments = (permissions.SearchDocuments || []).length > 0
  let showOrders = (permissions.Orders || []).length > 0
  let showInventoryStates = (permissions.InventoryStates || []).length > 0
  let showExpiringProducts = (permissions.ExpiringProducts || []).length > 0
  let showDistributionService = (permissions.DistributionService || []).length > 0
  let showBusinessRules = (permissions.BusinessRules || []).length > 0
  let showEcommerceSearchDocumentss = (permissions.EcommerceSearchDocuments || []).length > 0

  var formattedMenu = []

  /* Dashboard */
  var itemDashboard = {
    type: 'item',
    icon: 'monitor-icon',
    name: 'Monitoreo de Servicios',
    router: {
      name: 'ServiceMonitoring'
    }
  }

  /* Info Upload - Header */
  var itemInfoUpload = {
    type: 'tree',
    icon: 'cargar-icon',
    name: 'Cargar Información',
    items: [
    ]
  }

  /* Info Upload - Item */
  var itemReception = {
    type: 'item',
    icon: 'citas-r-icon',
    name: 'Citas de Recepción',
    router: {
      name: 'ReceptionAppointments'
    }
  }

  var itemDispatch = {
    type: 'item',
    icon: 'citas-d-icon',
    name: 'Citas de Despacho',
    router: {
      name: 'DispatchAppointments'
    }
  }

  var itemInventory = {
    type: 'item',
    icon: 'invetario-s-icon',
    name: 'Inventario',
    router: {
      name: 'Inventory'
    }
  }

  /* Document Monitoring */
  var itemDocumentSearch = {
    type: 'item',
    icon: 'seguimiento-icon',
    name: 'Seguimiento de Documento',
    router: {
      name: 'DocumentSearch'
    }
  }

  /* Document Ecommerce */
  var itemLogisticaEcommerce = {
    type: 'tree',
    icon: 'ecommerce-icon',
    name: 'Logística Ecommerce',
    items: [
    ]
  }

  var itemDocumentoEcommerce = {
    type: 'item',
    icon: 'ecommerce-icon',
    name: 'Documentos Ecommerce',
    router: {
      name: 'EcommerceSearchDocuments'
    }
  }

  /* Rules */
  var itemRules = {
    type: 'item',
    icon: 'reglas-icon',
    name: 'Reglas de Negocio',
    router: {
      name: 'AlertRules'
    }
  }

  /* Perishable Products */
  var itemPerishable = {
    type: 'item',
    icon: 'productos-icon',
    name: 'Productos Perecibles',
    router: {
      name: 'PerishableProducts'
    }
  }

  /* Orders Progress */
  var itemOrdersProgress = {
    type: 'item',
    icon: 'avance-icon',
    name: 'Avance de Pedidos',
    router: {
      name: 'OrdersProgress'
    }
  }

  /* Iventory Product Status */
  var itemInventoryProductStatus = {
    type: 'item',
    icon: 'inventario-e-icon',
    name: 'Inventario por Estado',
    router: {
      name: 'InventoryProductStatus'
    }
  }

  /* Dispatch Tracking */
  var itemDispatchTrcking = {
    type: 'item',
    icon: 'servicio-icon',
    name: 'Servicio de Distribución',
    router: {
      name: 'DispatchTracking'
    }
  }

  if (showDashboard) {
    formattedMenu.push(itemDashboard)
  }

  if (showReception) {
    itemInfoUpload.items.push(itemReception)
  }

  if (showDispatch) {
    itemInfoUpload.items.push(itemDispatch)
  }

  if (showInventory) {
    itemInfoUpload.items.push(itemInventory)
  }

  if (showReception || showDispatch || showInventory) {
    formattedMenu.push(itemInfoUpload)
  }

  /* Monitoring */
  if (showSearchDocuments) {
    formattedMenu.push(itemDocumentSearch)
  }

  /* Ecommerce */
  if (showEcommerceSearchDocumentss) {
    itemLogisticaEcommerce.items.push(itemDocumentoEcommerce)
  }

  if (showEcommerceSearchDocumentss) {
    formattedMenu.push(itemLogisticaEcommerce)
  }

  /* Rules */
  if (showBusinessRules) {
    formattedMenu.push(itemRules)
  }

  /* Perishable Products */
  if (showExpiringProducts) {
    formattedMenu.push(itemPerishable)
  }

  /* Orders Progress */
  if (showOrders) {
    formattedMenu.push(itemOrdersProgress)
  }

  /* Iventory Product Status */
  if (showInventoryStates) {
    formattedMenu.push(itemInventoryProductStatus)
  }

  /* Dispatch Tracking */
  if (showDistributionService) {
    formattedMenu.push(itemDispatchTrcking)
  }

  return formattedMenu
}

/**
  * @desc   Generates labels array based on Dates
  * @param  mode string - filter mode
  * @param  startDate string - filter start date
  * @param  endDate string - filter end date
  * @return array - label array based on Dates
*/
function getChartLabels (mode, startDate, endDate) {
  let labels = []

  switch (mode) {
    case constants.dashboardFilterModes.today:
      labels = constants.defaultChartLabels.day
      break
    default:
      let objStartDate = moment(startDate)
      let objEndDate = moment(endDate)

      let objCurrentDate = objStartDate

      while (objCurrentDate <= objEndDate) {
        labels.push(objCurrentDate.format('DD/MM'))
        objCurrentDate = objCurrentDate.add(1, 'days')
      }

      break
  }

  return labels
}

/**
  * @desc   evaluates chart data based on mode
  * @param  mode string - filter mode
  * @param  startDate string - filter start date
  * @param  endDate string - filter end date
  * @param  data object - data which will be displayed
  * @return array - formatted chart data array
*/
function getChartData (mode, startDate, endDate, data) {
  let finalData = []
  let rawData
  let chartLabels

  switch (mode) {
    case constants.dashboardFilterModes.today:
      chartLabels = constants.defaultChartLabels.day
      rawData = formatChartObject(data, 'h a')
      break
    default:
      chartLabels = getChartLabels(mode, startDate, endDate)
      rawData = formatChartObject(data, 'DD/MM')
      break
  }

  for (let index = 0; index < chartLabels.length; index++) {
    let rawDataIndex = rawData.labels.indexOf(chartLabels[index])

    if (rawDataIndex !== -1) {
      finalData.push(rawData.data[rawDataIndex])
    } else {
      finalData.push(0)
    }
  }

  return finalData
}

/**
  * @desc   formats chart data based on format
  * @param  data    object - data which will be formatted
  * @param  format  string - format in which date will be formatted
  * @return object - formatted chart data object
*/
function formatChartObject (data, format) {
  let obj = {
    labels: [],
    data: []
  }

  let lastDate, currentDate
  let totalAmount, currentAmount

  // Ascending Sort by Date
  data.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(a.dateTime) - new Date(b.dateTime)
  })

  for (let index = 0; index < data.length; index++) {
    currentDate = moment(data[index].dateTime).format(format)
    currentAmount = data[index].value

    if (index === 0) {                  // First Time
      lastDate = currentDate
      totalAmount = 0
    }

    if (lastDate === currentDate) {     // Same Date
      totalAmount += currentAmount
    } else {                            // Diff Date
      obj.labels.push(lastDate)
      obj.data.push(totalAmount)

      lastDate = currentDate
      totalAmount = currentAmount
    }

    if (index === (data.length - 1)) {  // Last Time
      obj.labels.push(lastDate)
      obj.data.push(totalAmount)
    }
  }

  return obj
}

/**
  * @desc   evaluates colors based on values
  * @param  value number - data which will be formatted
  * @return object - color object
*/
function getChartColors (value) {
  let solid, opaque

  if (value >= constants.minimunValues.success) {
    opaque = constants.colorPalette.hexSuccessOpa
    solid = constants.colorPalette.hexSuccess
  } else if (value >= constants.minimunValues.warning) {
    opaque = constants.colorPalette.hexWarningOpa
    solid = constants.colorPalette.hexWarning
  } else {
    opaque = constants.colorPalette.hexDangerOpa
    solid = constants.colorPalette.hexDanger
  }
  return {solid: solid, opaque: opaque}
}

/**
  * @desc   generates Year list based on range
  * @param  start number - Start Year
  * @param  end   number - End Year
  * @return object - Year Object (current Year and Year range list)
*/
function getYearList (start, end) {
  let obj = {
    current: moment().year(),
    list: []
  }

  if (!end) {
    end = obj.current
  }

  for (let index = start; index <= end; index++) {
    obj.list.push(index)
  }

  return obj
}

/**
  * @desc   generates Month list
  * @return object - Month Object (current Month and Month list)
*/
function getMonthList () {
  let obj = {
    current: null,
    list: []
  }

  moment.locale('es')

  let monthList = moment.months()

  for (let index = 0; index < monthList.length; index++) {
    obj.list.push({
      name: monthList[index].charAt(0).toUpperCase() + monthList[index].slice(1),
      value: (index + 1).toString().padStart(2, '0')
    })
  }

  obj.current = obj.list[moment().month()]

  return obj
}

/* Export */
export default {
  formatSlideMenuItems,
  getChartLabels,
  getChartData,
  getChartColors,
  getYearList,
  getMonthList
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js